export default {
    data() {
        const date = new Date();
        const months = ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"];
        const currentYear = date.getFullYear();
        const currentMonth = months[date.getMonth()];
        return { menuItems : [
    {
        id: 1,
        label: 'Početna',
        icon: 'esei icon-home',
        link: '/',
        name: {name: 'index'},

        lang: 'sr'
    },
    {
        id: 2,
        label: 'Oglasi',
        icon: 'esei icon-bullhorn',
        link: '/oglasi/svi-oglasi/1',
        name: {name: 'oglasi-svi-oglasi-page', params: { page: 1 }},
        lang: 'sr'
    },
    {
        id: 22,
        label: 'Tezge',
        icon: 'esei icon-store-solid',
        link: '/tezge/1',
        name: {name: 'tezge-page', params:{page: 1}},
        lang: 'sr'
    },
    {
        id: 3,
        label: 'Kalendar',
        icon: 'esei icon-calendar-solid',
        link: '/kalendar-dogadjaja/dogadjaji/2025/januar/1',
        name: {name: 'kalendar-dogadjaja-dogadjaji-year-month-page', params: {year:currentYear, month: currentMonth, page: 1 }},
        lang: 'sr',
        subItems: [
            {
                id: 1,
                label: 'Kalendari',
                link: '/kalendar-dogadjaja/dogadjaji/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-dogadjaji-year-month-page', params: {year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 2,
                label: 'Kalendar zelenih pijaca',
                link: '/kalendar-dogadjaja/kalendar-zelenih-pijaca/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'kalendar-zelenih-pijaca', year:currentYear, month: currentMonth, page: 1 }},

            },
            {
                id: 3,
                label: 'Kalendar stočnih pijaca',
                link: '/kalendar-dogadjaja/kalendar-stocnih-pijaca/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'kalendar-stocnih-pijaca', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 4,
                label: 'Kalendar seoskih slava',
                link: '/kalendar-dogadjaja/kalendar-seoskih-slava/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'kalendar-seoskih-slava', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 5,
                label: 'Kalendar vašara',
                link: '/kalendar-dogadjaja/kalendar-vasara/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'kalendar-vasara', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 6,
                label: 'Kalendar fijakerijada',
                link: '/kalendar-dogadjaja/kalendar-fijakerijada/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'kalendar-fijakerijada', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 7,
                label: 'Kalendar događaja i manifestacija',
                link: '/kalendar-dogadjaja/kalendar-dogadjaja-i-manifestacija/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'kalendar-dogadjaja-i-manifestacija', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 8,
                label: 'Školski kalendar',
                link: '/kalendar-dogadjaja/skolski-kalendar/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'skolski-kalendar', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 9,
                label: 'Doček Nove godine',
                link: 'kalendar-dogadjaja/docek-nove-godine/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'docek-nove-godine', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 10,
                label: 'Kalendar državnih praznika',
                link: '/kalendar-dogadjaja/kalendar-drzavnih-praznika/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'kalendar-drzavnih-praznika', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 11,
                label: 'Moto skupovi',
                link: '/kalendar-dogadjaja/moto-skupovi/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'moto-skupovi', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 12,
                label: 'Koncerti',
                link: '/kalendar-dogadjaja/koncerti/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'koncerti', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 13,
                label: 'Izložbe pasa',
                link: '/kalendar-dogadjaja/izlozbe-pasa/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'izlozbe-pasa', year:currentYear, month: currentMonth, page: 1 }},
            },
            {
                id: 14,
                label: 'Program',
                link: '/kalendar-dogadjaja/program/kategorija/2025/januar/1',
                name: {name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: {event: 'program', year:currentYear, month: currentMonth, page: 1 }},
            },
        ]
    },
 
    {
        id: 4,
        label: 'Cene',
        icon: 'esei icon-apple-whole-solid',
        lang: 'sr',
        name: false,
        subItems: [
            {
                id: 0,
                label: 'Istorijske cena na pijacama u Srbiji',
                link: '/cena-na-pijacama/cene-stoke-na-pijacama',
                name: {name: 'cene-istorija-categoryhistory', params: {categoryhistory: 'cene-stoke-na-pijacama'}},
            },
            {
                id: 0,
                label: 'Cena na pijacama u Srbiji i regionu',
                link: '/cena-na-pijacama/cene-stoke-na-pijacama',
                name: {name: 'cene-na-pijacama-srbija-bosna-i-hercegovina-hrvatska'},
            },
            {
                id: 1,
                label: 'Cena opreme i mašina za baštu i dvorište',
                link: '/kategorija/cene-opreme-i-masina-za-bastu-i-dvoriste',
                name: {name: 'kategorija-category',params: {category: 'cena-opreme-i-masina-za-bastu-i-dvoriste'}},
            },
            {
                id: 2,
                label: 'Cena stoke na pijacama',
                link: '/cena-na-pijacama/cene-stoke-na-pijacama',
                name: {name: 'cena-na-pijacama-products',params: {products: 'cene-stoke-na-pijacama'}},
            },
            {
                id: 3,
                label: 'Cena voća na pijacama',
                link: '/cena-na-pijacama/cene-voca-na-pijacama',
                 name: {name: 'cena-na-pijacama-products',params: {products: 'cene-voca-na-pijacama'}},
            },
            {
                id: 4,
                label: 'Cena povrća na pijacama',
                link: '/cena-na-pijacama/cene-povrca-na-pijacama',
                 name: {name: 'cena-na-pijacama-products',params: {products: 'cene-povrca-na-pijacama'}},
            },
            {
                id: 5,
                label: 'Cena žitarica na pijacama',
                link: '/cena-na-pijacama/cene-zitarica-na-pijacama',
                 name: {name: 'cena-na-pijacama-products',params: {products: 'cene-zitarica-na-pijacama'}},
            },
            {
                id: 6,
                label: 'Cena jaja i mleka',
                link: '/cena-na-pijacama/cene-jaja-i-mleka-na-pijacama',
                 name: {name: 'cena-na-pijacama-products',params: {products: 'cene-jaja-i-mleka-na-pijacama'}},
            },         
            {
                id: 7,
                label: 'Cena južnog voća na pijacama',
                link: '/cena-na-pijacama/cene-juznog-voca-na-pijacama',
                 name: {name: 'cena-na-pijacama-products',params: {products: 'cene-juznog-voca-na-pijacama'}},
            },
            {
                id: 8,
                label: 'Cena drva na pijacama',
                link: '/cene-na-pijacama/cene-drva-na-pijacama',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-drva-na-pijacama'}},
            },
            {
                id: 9,
                label: 'Cena meda na pijacama',
                link: '/cene-na-pijacama/cene-meda-na-pijacama',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-meda-na-pijacama'}},
            },
            {
                id: 10,
                label: 'Cena sušenog mesa na pijacama',
                link: '/cene-na-pijacama/cene-susenog-mesa-na-pijacama',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-susenog-mesa-na-pijacama'}},
            },
            {
                id: 11,
                label: 'Cene goriva na pumpama',
                link: '/cene-na-pijacama/cene-goriva-na-pumpama',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-goriva-na-pumpama'}},
            },
            {
                id: 12,
                label: 'Cene ribe na pijacama',
                link: '/cene-na-pijacama/cene-ribe-na-pijacama',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-ribe-na-pijacama'}},
            },{
                id: 13,
                label: 'Cene mesa u mesarama',
                link: '/cene-na-pijacama/cene-mesa-u-mesarama',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-mesa-u-mesarama'}},
            },
            {
                id: 14,
                label: 'Cene u marketima',
                link: '/cene-na-pijacama/cene-u-marketima',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-u-marketima'}},
            },{
                id: 15,
                label: 'Cene pečenog mesa',
                link: '/cene-na-pijacama/cene-pecenog-mesa',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-pecenog-mesa'}},
            },{
                id: 16,
                label: 'Cene rakije na pijacama',
                link: '/cene-na-pijacama/cene-rakije-na-pijacama',
                name: {name: 'cene-na-pijacama-category',params: {category: 'cene-rakije-na-pijacama'}},
            }
        ]
    },
    {
        id: 5,
        label: 'Crkveni kalendar',
        icon: 'esei icon-church-solid',
        link: '/kalendar-dogadjaja/dogadjaji/2025/januar/1',
        lang: 'sr',
        subItems: [
            {
                id: 1,
                label: `Crkveni kalendar godinu`,
                link: '/crkveni-kalendar',
                name: {name: 'crkveni-kalendar'},
            },
            {
                id: 3,
                label: `Kalendar posta za ${currentYear} godinu`,
                link: '/crkveni-kalendar/kalendar-posta/za-godinu/2025',
                name: {name: 'crkveni-kalendar-kalendar-posta-za-godinu-year', params: { year: currentYear}},
            },
            {
                id: 4,
                label: `Mesečeve mena za ${currentYear} godinu`,
                link: '/crkveni-kalendar/meseceve-mene-za-godinu/2025',
                name: {name: 'crkveni-kalendar-meseceve-mene-za-godinu-year', params: { year: currentYear}},
            },
            {
                id: 5,
                label: `Zadušnice za ${currentYear} godinu`,
                link: '/crkveni-kalendar/zadusnice/2025',
                name: {name: 'crkveni-kalendar-zadusnice-year', params: { year: currentYear}},
            },
            {
                id: 6,
                label: `Crkveni kalendar za januar ${currentYear}`,
                link: '/crkveni-kalendar/za-mesec/januar-2025',
                name: {name: 'crkveni-kalendar-za-mesec-month', params: { month: 'januar-' + currentYear}},
            },
             {
                id: 7,
                label: `Crkveni kalendar za februar ${currentYear}`,
                link: '/crkveni-kalendar/za-mesec/januar-2025',
                name: {name: 'crkveni-kalendar-za-mesec-month', params: { month: 'februar-' + currentYear}},
            },
            {
    id: 8,
    label: `Crkveni kalendar za mart ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/mart-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'mart-' + currentYear }
    },
},
{
    id: 9,
    label: `Crkveni kalendar za april ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/april-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'april-' + currentYear }
    },
},
{
    id: 10,
    label: `Crkveni kalendar za maj ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/maj-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'maj-' + currentYear }
    },
},
{
    id: 11,
    label: `Crkveni kalendar za jun ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/jun-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'jun-' + currentYear }
    },
},
{
    id: 12,
    label: `Crkveni kalendar za jul ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/jul-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'jul-' + currentYear }
    },
},
{
    id: 13,
    label: `Crkveni kalendar za avgust ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/avgust-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'avgust-' + currentYear }
    },
},
{
    id: 14,
    label: `Crkveni kalendar za septembar ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/septembar-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'septembar-' + currentYear }
    },
},
{
    id: 15,
    label: `Crkveni kalendar za oktobar ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/oktobar-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'oktobar-' + currentYear }
    },
},
{
    id: 16,
    label: `Crkveni kalendar za novembar ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/novembar-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'novembar-' + currentYear }
    },
},
{
    id: 17,
    label: `Crkveni kalendar za decembar ${currentYear}`,
    link: `/crkveni-kalendar/za-mesec/decembar-${currentYear}`,
    name: {
        name: 'crkveni-kalendar-za-mesec-month',
        params: { month: 'decembar-' + currentYear }
    },
},
            
        ]
    },
    {
        id: 6,
        label: 'Ostalo',
        icon: 'esei icon-clipboard-solid',
        lang: 'sr',
        name: false,
        subItems: [
            {
                id: 1,
                label: 'Imena životinja',
                link: '/imena-zivotinja',
                name: {name: 'imena-zivotinja'},
            },
            {
                id: 2,
                label: 'Kalendar okota životinja',
                link: '/kalendar-okota-zivotinja',
                name: {name: 'kalendar-okota-zivotinja'},
            },
            
            {
                id: 3,
                label: 'Zaštita od bolesti',
                link: '/zastita',
                name: {name: 'zastita'},
            },
            {
                id: 4,
                label: 'Bolesti, štetočine, korovi',
                link: '/bolesti',
                name: {name: 'bolesti'},
            },
           
            {
                id: 5,
                label: 'Vesti',
                link: '/vesti',
                name: {name: 'vesti-poljoprivredne-novosti-page', params: {page: 1}},
            },
            {
                id: 6,
                label: 'Preporuke',
                link: '/preporuke',
                name: {name: 'preporuke'},
            },
            {
                id: 7,
                label: 'Saveti',
                link: '/saveti',
                name: {name: 'saveti'},
            },
            {
                id: 8,
                label: 'Ankete',
                link: '/anketa',
                name: {name: 'anketa'},
            },
            {
                id: 9,
                label: 'Adresar',
                link: '/adresari/kategorije/1',
                name: {name: 'adresari-kategorije-page',params:{page: 1}},
            },
            {
                id: 10,
                label: 'Video',
                link: '/video',
                name: {name: 'video'},
            },
            {
                id: 11,
                label: 'Recepti',
                link: '/recepti/1',
                name: {name: 'recepti-page', params: {page: 1}},
            },
            {
                id: 12,
                label: 'Kako pomaže',
                link: '/kako-pomaze/kategorije/1',
                name: {name: 'kako-pomaze-kategorije-page', params: {page: 1}},
            },
            {
                id: 13,
                label: 'Đeram pijaca',
                link: '/djeram-pijaca-beograd',
                name: {name: 'djeram-pijaca-beograd'},
            },
             {
                id: 14,
                label: 'Palilulska pijaca',
                link: '/palilulska-pijaca-beograd',
                name: {name: 'palilulska-pijaca-beograd'},
            },
            {
                id: 15,
                label: 'Cvetkova pijaca',
                link: '/cvetkova-pijaca-beograd',
                name: {name: 'cvetkova-pijaca-beograd'},
            },
        ]
    },

    {
        id: 7,
        label: 'Marketing',
        icon: 'esei icon-sign-hanging-solid',
        link: '/marketing',
        name: {name: 'marketing'},
        lang: 'sr'
    }, {
        id: 8,
        label: 'Cenovnik',
        icon: 'esei icon-money-bill-solid',
        name: {name: 'cenovnik'},
        link: '/cenovnik',
        lang: 'sr'
    }, {
        id: 9,
        label: 'Kontakt',
        icon: 'esei icon-phone',
        name: {name: 'kontakt'},
        link: '/kontakt',
        lang: 'sr'
    },
]
    }
}
}
